export default __webpack_public_path__ + "static/media/Guatemaya.a1e99d8c.png";